// extracted by mini-css-extract-plugin
module.exports = {"shape":"shape___woz25","hasShine":"hasShine___3Q9Y7","shine":"shine___3wXPF","darker":"darker___3pJxz","centered":"centered___7Jt8Y"};